import React from 'react'
import queryString from 'qs'
import { hasData, Gtm } from 'helpers'
import { Button, Picker, ScrollerSelect, ChooseAmount, Loader } from 'components'
import { ArrowLeftIcon, PlusIcon } from 'assets/icons'
import { ArticleTypes, BasketTypes } from 'types'
import { RouteComponentProps, Link } from 'react-router-dom'
import { API, PAGE_TYPES } from 'src/constants'

import './ProductDetail.scss'

interface Props extends RouteComponentProps<any> {
    article:  ArticleTypes.Article,
    weeks: Item[],
    basket: BasketTypes.Item[],
    addToBasket: Function
}

interface State {
    article: BasketTypes.Item,
    weeks: Item[],
    week: any,
    year: number,
    weekIndex: number,
    series: ArticleTypes.Article[],
    currentQuantity: number
}
interface Item {
    id: number,
    label: string
}

let defaultState = {
    article: {
        id: '',
        articleId: '',
        name: '',
        productGroupName: '',
        formId: '',
        formName: '',
        packingUnit: 0,
        week: 0,
        year: 0,
        quantity: 0,
        availability: []
    },
    week: 0,
    year: 0,
    weekIndex: 0,
    weeks: [],
    series: [],
    currentQuantity: 0
}

class ProductDetail extends React.Component<Props, State> {

    static createWeeks = (weeks: number[]) => {
        return weeks.map((week: number) => {
            return {
                label: 'week ' + week,
                id: week
            }
        })
    }

    static getDerivedStateFromProps ( nextProps: any ) {

        const { articles, weeks } = nextProps.data
        if (nextProps.data && articles) {
            const articleById = articles.filter((item: ArticleTypes.Article) => item.id === nextProps.match.params.id)
            const generateWeeks = ProductDetail.createWeeks(weeks)
            const currentWeek = queryString.parse(nextProps.location.search) ?
                parseInt(queryString.parse(nextProps.location.search.slice(1)).week, 10) :
                0
            const getSeries = articleById[0].seriesID === null ?
                [{...articleById[0]}] :
                articles.filter((item: ArticleTypes.Article) => item.seriesID === articleById[0].seriesID)
            return {
                article: articleById[0],
                week: currentWeek,
                year: new Date().getFullYear(),
                weekIndex: articleById[0].availability.findIndex( (item: any) => item.week === currentWeek ),
                series: getSeries,
                weeks: generateWeeks
            }
        } else {
            return null
        }
    }

    constructor(props: Props) {
        super(props)
        this.state = defaultState
    }

    public componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('page-product-detail')
        const { article } = this.state
        // GTM
        Gtm.pushPageType(PAGE_TYPES.PRODUCTS)
        Gtm.pushFlowEvent('productDetail', {
            detail: {
                products: [{
                    name: `${article.productGroupName} - ${article.name}`,
                    id: article.articleId,
                    brand: 'New Surplus Order',
                    variant: article.formId
                }]
            }
        })
        // End GTM
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('page-product-detail')
    }

    public handleWeekUpdate = ( week: any ) => {
        const weekIndex = this.state.article.availability.findIndex( (item: any) => item.week === week )
        this.setState({
            week: week,
            currentQuantity: 0,
            year: this.state.article.availability[weekIndex].year,
            weekIndex: weekIndex
        })
        this.props.history.push({
            search: '?week=' + week
        })
    }

    public handlePicker = ( item: any ) => {
        this.props.history.push({
            pathname: '/add/' + item,
            search: '?week=' + this.state.week
        })
    }

    public setQuantity = (value: number) => {
        this.setState({
            currentQuantity: value
        })
    }

    public handleClick ( addToBasket: Function ) {
        let basketItem = {
            ...this.state.article,
            quantity: this.state.currentQuantity,
            week: this.state.week,
            year: this.state.year
        }
        addToBasket(basketItem)
    }

    public render() {

        const { article, weeks, week, series, weekIndex } = this.state

        return (
            <React.Fragment>
                {article.id ?
                    <section className="page-layout">
                        <header>
                            <Link to="/search" className="button--link">
                                <ArrowLeftIcon fill="#000000"/>
                                Back
                            </Link>
                        </header>
                        <main>
                            <section id="product-detail">
                                <header>
                                    <h1 className="u-h2">{article.productGroupName}</h1>
                                    <p>Select deliveryweek and totals</p>
                                </header>
                                <div className="u-padding-left--sm u-padding-right--sm">
                                    <Picker
                                        basket={this.props.basket}
                                        activeId={article.id}
                                        listItems={series}
                                        onUpdate={this.handlePicker}
                                    />
                                    <div className="u-margin-top--md u-margin-bottom--md">
                                        <ScrollerSelect
                                            onUpdate={this.handleWeekUpdate}
                                            activeId={week}
                                            listItems={weeks}
                                        />
                                    </div>
                                </div>
                                <ChooseAmount
                                    max={article.availability[weekIndex].quantity}
                                    step={article.packingUnit}
                                    onUpdate={this.setQuantity}
                                />
                                <footer>
                                    {article.formName}
                                </footer>
                            </section>
                        </main>
                        <footer>
                            <Button
                                full={true}
                                disabled={this.state.currentQuantity === 0}
                                onClick={(e) => this.handleClick(this.props.addToBasket)}
                            >
                                <PlusIcon width={20} />
                                Add to basket
                            </Button>
                        </footer>
                    </section> :
                    <Loader />
                    }
            </React.Fragment>
        )
    }
}

export default hasData({
    url: API.host + API.endpoints.surplus + '?companyId=10'
})(ProductDetail)



// WEBPACK FOOTER //
// ./src/containers/ProductDetail/index.tsx